import Api from "../api";

let uri = "/api/ed/capacitacion";

export const crearActa = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/`, data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const actualizarActa = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(`${uri}/`, data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const obtenerActa = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/acta`, data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const crearActaCliente = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/cliente`, data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};
